import { Box, Button, Grid, Stack } from '@mui/material'
import FlowHeader from '../Components/FlowHeader'
import WizardButton from '../Components/WizardButton'
import { HostCompany, Vessel } from '@griegconnect/krakentools-react-icons'
import { NextState, StepProps, VisitType, nextStateAtom } from '.'
import { useRecoilState } from 'recoil'
import { useTranslation } from 'react-i18next'
import FlowPage from '../Components/FlowPage'
import FlowNavigation from '../Components/FlowNavigation'

export const StepVisitType: React.FC<StepProps> = ({ resetForm, formType }) => {
  const [state, setState] = useRecoilState<NextState>(nextStateAtom)
  const { t } = useTranslation()

  const handleDone = (visitType: VisitType) => {
    setState((prevState) => ({
      ...prevState,
      mode: 'schema',
      visitType: visitType,
      currentStep: prevState.currentStep + 1,
    }))
  }

  const handleReset = () => resetForm && resetForm()

  // const onBack = () => setState((p) => ({ ...p, currentStep: p.currentStep - 1 }))

  if (state.visitType === undefined) {
    return (
      <>
        <FlowHeader i18n="applications.subTitle.visitingWhat" />
        <Grid container spacing={1} mt={2}>
          <Grid item xs={6}>
            <WizardButton icon={Vessel} onClick={() => handleDone('vessel')} buttonText={t('settings.labels.vessel')} />
          </Grid>
          <Grid item xs={6}>
            <WizardButton
              icon={HostCompany}
              onClick={() => handleDone('company')}
              buttonText={t('security.labels.visitingCompany')}
            />
          </Grid>
        </Grid>
      </>
    )
  } else {
    return (
      <Box width="100%">
        <FlowPage>
          <Stack direction="column" spacing={2} justifyContent="center" alignItems="flex-start">
            <FlowHeader i18n="applications.subTitle.visitingWhat" />
            <Stack direction="row" spacing={2} width="100%">
              <WizardButton
                icon={Vessel}
                onClick={() => handleDone('vessel')}
                buttonText={t('settings.labels.vessel')}
                selected={state.visitType === 'vessel'}
              />
              <WizardButton
                icon={HostCompany}
                onClick={() => handleDone('company')}
                buttonText={t('security.labels.visitingCompany')}
                selected={state.visitType === 'company'}
              />
            </Stack>
          </Stack>
        </FlowPage>
        <FlowNavigation>
          <Stack direction="row" width="100%">
            {formType === 'new' && (
              <Box display="flex" justifyContent="flex-start" width="100%">
                <Button color="inherit" onClick={handleReset}>
                  {t('applications.actions.reset')}
                </Button>
              </Box>
            )}
            <Box display="flex" justifyContent="flex-end" width="100%">
              {/* <Button variant="outlined" onClick={onBack} style={{ marginRight: 10 }}>
                {t('common.actions.back')}
              </Button> */}
              <Button
                variant="contained"
                type="submit"
                onClick={() => setState((p) => ({ ...p, currentStep: p.currentStep + 1 }))}
              >
                {t('common.actions.continue')}
              </Button>
            </Box>
          </Stack>
        </FlowNavigation>
      </Box>
    )
  }
}
export default StepVisitType
